export const ROUTES_CONST = {
  START: '',
  EGO_CHAT: 'ego-chat',
  TRAINING: 'training',
  LEARNING: 'learning',
  PRACTICE: 'practice',
  TICKET: 'ticket',
  TESTING: 'testing',
  SETTINGS: 'settings',
  ABOUT: 'about',
  PARENT_LEARN: 'parentlearn',
  ADULT_LEARN: 'adultlearn',
  CHILD_LEARN: 'childlearn',
};
